<ng-template #container>
	<div
		class="modal-backdrop fade show"
		[style.z-index]="zIndex - 1"
	></div>
	<div
		class="modal fade show"
		tabindex="-1"
		role="dialog"
		(mousedown)="close()"
		style="display: block"
		[style.z-index]="zIndex"
		animate.enter="enter-animation"
	>
		<div
			#modalDialog
			class="modal-dialog"
			[ngClass]="modalWrapperClass"
			(mousedown)="headerClick($event)"
			(click)="innerClick($event)"
		>
			<div class="modal-content">
				<div
					class="modal-header"
					(mousedown)="headerMouseDown($event)"
					(mouseup)="headerMouseUp($event)"
					(click)="headerClick($event)"
				>
					<button
						class="close"
						(click)="close()"
						aria-label="Close"
						icon="modal-close"
					></button>
					<div class="flex-v-center flex-grow-1">
						@if (title) {
							<h3>{{ title | langVal }}</h3>
						}
						<ng-content select="[header]" />
					</div>
				</div>

				<div class="modal-body">
					<ng-content />
					@if (hasExit) {
						<div class="modal-btns">
							<app-btn-ext
								text="exit"
								(clickEv)="close()"
							/>
						</div>
					}
				</div>
			</div>
		</div>
	</div>
</ng-template>
